module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"total_reviews_count":"{0}个"}}')
  delete Component.options._Ctor
}
